export default {"src":"/_next/static/media/ra-aircraft-skiing.e575a5f6.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};